import React from "react";

export const Card = ({
  language,
  key,
  title,
  skill,
  hosted,
  description,
  lesson,
  year,
  url,
  gitUrl,
  imgSrc,
  alt,
}) => {

  let text1 = "";
  let text2 = "";
  let text3 = "";
  let text4 = "";
  let text5 = "";

  if (language === "English") {
    text1 = "Show Description";
    text2 = "Hosted in";
    text3 = "Go to the project";
    text4 = "Check my code in GIT";
    text5 = "Here";
  } else if (language === "Spanish") {
    text1 = "Ver descripción";
    text2 = "Alojado en";
    text3 = "Ir al proyecto";
    text4 = "Checkeá mi código en GIT";
    text5 = "Aquí";
  } 
  return (
    <div id="card" className="timeline-block">
      <div className="marker" />
      <div className="timeline-content">
        <h1>{title}</h1>
        <h3>{description}</h3>
        <h4>{year}</h4>
        <span>
          <strong>{skill}</strong>
        </span>
        <br></br>

        <div>
          <p>
            <button
              className="btn btn-primary"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseWidthExample"
              aria-expanded="false"
              aria-controls="collapseWidthExample"
            >
              {text1}
            </button>
          </p>
          <div style={{ minHeight: "10px"}}>
            <div
              className="collapse collapse-horizontal"
              id="collapseWidthExample"
            >
              <div
                className="card card-body"
                style={{ width: "100%", background: "transparent", "font-size": "12px"}}
              >
                {lesson}
              </div>
            </div>
          </div>
        </div>

        <span>
          {text2}: <strong>{hosted}</strong>
        </span>
        <p className="links">
          {text3}: <a href={url} target="_blank"> {text5}</a>
        </p>
        <p className="links">
          {text4}: <a href={gitUrl} target="_blank"> {text5}</a>
        </p>
      <br></br>
      <br></br>
      </div>
      <div className="timeline-image">
        <img className="ProjImg" src={imgSrc} alt={alt} />  
      </div>
      
    </div>
  );
};

export default Card;
